import { UserDashboardResponseModel } from 'shared/models';
import { makeQueryRaw } from 'shared/utilities';

type ResponseType = UserDashboardResponseModel;

export const userDashboardsGetQuery = async function () {
    return await makeQueryRaw<ResponseType>('/user-dashboards/get');
}
